import { css, Theme } from '@emotion/react'

export const title = css`
  font-weight: 700;
  margin: 24px 0;
`

export const tab = (theme: Theme) => css`
  font-weight: 600;
  color: ${theme.typographyColors.typographyThree};
  padding: 12px 12px 8px;
  border-radius: 12px;
  cursor: pointer;
`

export const activeTab = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyTwo};
  background: ${theme.colors.grayHover};
`

export const tabsBlock = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 24px;
`

export const card = css`
  grid-template-columns: 24px 329px 329px 229px 29px 52px;
`

export const badge = css`
  max-width: 229px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const link = (theme: Theme) => css`
  color: ${theme.colors.blueHover};
`
